import Image from "next/image";

import ChevronRightIcon from "@repo/ui-system/icons/arrows/chevron-right/outline.svg";

import { OutboundLink } from "@/features/outbound-link/outbound-link";
import { type BestQuickPicksItem } from "@/lib/api/best/quick-picks/schema";
import { BiEvent } from "@/lib/bi/bi.enum";

type Props = {
  item: BestQuickPicksItem;
};

export function QuickPickCard({ item }: Props) {
  return (
    <OutboundLink
      url={item.url}
      storeName="amazon"
      bi={{
        eventType: BiEvent.BannerOutbound,
        id: String(item.id),
        provider: "amazon",
        location: "quick-picks",
      }}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className="relative z-2 -mb-3 pl-4">
        <span className="mini3 rounded bg-surface-primary-lighter px-1 py-0.5 text-text-primary-default">
          {item.label}
        </span>
      </div>

      <div className="relative flex gap-3 rounded-2xl border border-border-grayscale-default px-3 pb-4 pt-5 transition-colors">
        <div className="flex shrink-0 items-center justify-center bg-white rounded-xl">
          <Image
            src={item.image}
            alt={item.name}
            width={52}
            height={52}
            sizes="52px"
            className="size-[52px] object-contain mix-blend-multiply"
          />
        </div>

        <div className="flex min-w-0 flex-1 flex-col gap-4">
          <div className="flex flex-col gap-1">
            <p className="sub1 line-clamp-1 text-text-grayscale-title">
              {item.title}
            </p>
            <p className="mini2 truncate text-text-grayscale-caption">
              {item.name}
            </p>
          </div>
          <span className="body2 flex items-center gap-2 text-primary underline">
            Check on Amazon
            <ChevronRightIcon className="size-4 shrink-0" />
          </span>
        </div>
      </div>
    </OutboundLink>
  );
}
